import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PageVersion } from 'src/app/model/shared/page-version';
import { PageVersionService } from 'src/app/service/page-version.service';

import { APIReferenceOverviewPageComponent } from '../api-reference-overview-page/api-reference-overview-page.component';
import { APIReferenceRequestPageComponent } from '../api-reference-request-page/api-reference-request-page.component';

@Component({
  selector: 'app-api-reference-page',
  templateUrl: './api-reference-page.component.html',
  styleUrls: ['./api-reference-page.component.scss']
})
export class APIReferencePageComponent implements OnInit {
  @Input() apiName: string = '';
  @Input() tabName: string = '';
  @Input() apiTabs: string[] = [];
  @Input() apiTabsClass: string[] = [];
  @Input() pageTitle: string = '';
  @Input() isTab: boolean = false;
  @Input() isTabOverride: boolean = false;
  @Input() href: string = '';
  @Input() selectedIndex: number = 0;

  @ViewChild(APIReferenceOverviewPageComponent)
  apiReferenceOverviewPageComponent!: APIReferenceOverviewPageComponent;

  @ViewChild(APIReferenceRequestPageComponent)
  apiReferenceRequestPageComponent!: APIReferenceRequestPageComponent;

  constructor(private pageVersionService: PageVersionService) {}

  ngOnInitWithPageTitleForOverview(pageTitle: string) {
    // console.log('>>>> >>>> APIReferencePageComponent invoked ngOnInitWithPageTitleForOverview');

    this.selectedIndex = 0;
    this.setPageTitle(pageTitle);

    if (this.apiReferenceOverviewPageComponent) {
      this.apiReferenceOverviewPageComponent.ngOnInitWithPageTitle(pageTitle);
    }
  }

  ngOnInitWithPageTitleForRequest(pageTitle: string) {
    // console.log('>>>> >>>> APIReferencePageComponent invoked ngOnInitWithPageTitleForRequest');

    this.selectedIndex = 1;
    this.setPageTitle(pageTitle);

    if (this.apiReferenceRequestPageComponent) {
      this.apiReferenceRequestPageComponent.ngOnInitWithPageTitle(pageTitle);
    }
  }

  ngOnInitWithPageTitleForResponse(pageTitle: string) {
    // console.log('>>>> >>>> APIReferencePageComponent invoked ngOnInitWithPageTitleForResponse');

    this.selectedIndex = 2;
    this.setPageTitle(pageTitle);
  }

  ngOnInit(): void {
    // console.log('apiName : ', this.apiName);
    // console.log('tabName : ', this.tabName);
    // console.log('pageTitle : ', this.pageTitle);
    // console.log('apiTabs : ', this.apiTabs);
    // console.log('isTabOverride : ', this.isTabOverride);
    // console.log('selectedIndex : ', this.selectedIndex);
  }

  setPageTitle(value: string) {
    // console.log(value);

    if (value.length > 0) {
      this.pageTitle = value;
    }

    let pageVersion: PageVersion = {} as PageVersion;
    pageVersion.pageName = this.pageTitle;
    pageVersion.selectedPageVersion = '';
    // console.log('reset selection : ', pageVersion);
    this.pageVersionService.addPageVersionData(pageVersion);
  }
}
